// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kzMzv","logo":"Header_logo__zUt32","cart":"Header_cart__ZzvAQ"};